import React from "react";
import "./RangeExtremumBadge.css";

export function rangeExtremumDescription(evidence) {
  if (!["HIGH", "LOW"].includes(evidence?.side)) return null;
  const side = evidence.side === "HIGH" ? "highest" : "lowest";
  return `Source wick is the ${side} across ${evidence.candleCount} retained candles for this market and timeframe, before the trigger candle. Recorded when the event was detected; equal peaks qualify.`;
}

export default function RangeExtremumBadge({ evidence }) {
  const description = rangeExtremumDescription(evidence);
  if (!description) return null;
  return <span className="range-extremum-badge" title={description}>
    Range {evidence.side === "HIGH" ? "high" : "low"}
  </span>;
}
